<template>
  <div class="home_w">
    <main>
      <div class="div_1 site_content">
        <div class="div_2 d_flex justify_content_sb">
          <div class="d_flex flex_direction_col">
            <!-- 标的类型 -->
            <TargetType />

            <!-- 所在区域 -->
            <BelongArea />
          </div>

          <!-- 焦点轮播 -->
          <FocusBanner />

          <div class="d_flex flex_direction_col">
            <!-- 搜索 -->
            <AllSearch />
            <!-- 中心动态 -->
            <CenterDynamic code="trend" :nodeData="childNodesData" />
          </div>
        </div>

        <!-- 公告公示 -->
        <Publicity />
        <!-- 竞价大厅 -->
        <Trade />
        <!-- 竞拍流程 -->
        <DealProcess />
        <!-- 广告 -->
        <Adverts code="index_hall" />

        <!-- 项目公告 -->
        <!-- <Project /> -->

        <!-- 广告 -->
        <!-- <Adverts code="index_project" /> -->
        <div
          class="column-title fz20 c_1A1A1A font_w_bold"
          style="margin-top: 30px"
        >
          政策法规
        </div>
        <div class="d_flex justify_content_sb" style="margin-bottom: 20px">
          <!-- 国家法规 -->
          <cmsChildNode code="cstatute" :nodeData="childNodesData" />
          <!-- 省级法规 -->
          <cmsChildNode code="pstatute" :nodeData="childNodesData" />
          <!-- 地方法规 -->
          <cmsChildNode code="dfstatute" :nodeData="childNodesData" />
        </div>

        <FloatingBox />

        <!-- 统一规范 -->
        <!-- <div
          class="unified_w"
          :style="{
            background: `url(${require('@/assets/images/wB6cGD8eVBF96EJA.png')})
      0 center no-repeat`,
          }"
        /> -->
      </div>
    </main>
  </div>
</template>

<script>
import TargetType from "./TargetType.vue";
import BelongArea from "./BelongArea.vue";
import FocusBanner from "./FocusBanner.vue";
import AllSearch from "./AllSearch.vue";
import CenterDynamic from "./CenterDynamic.vue";
import Publicity from "./Publicity.vue";
import FloatingBox from "@/components/base/FloatingBox.vue";
import Trade from "./Trade.vue";
import DealProcess from "@/views/public_0983cc/home/public/DealProcess.vue";
import Adverts from "@/views/public_0983cc/home/public/Adverts.vue";
import Project from "@/views/public_0983cc/home/public/Project.vue";

import cmsChildNode from "@/components/template/cmsChildNode.vue";

import { mapGetters, mapActions } from "vuex";
export default {
  name: "Async",
  components: {
    TargetType,
    BelongArea,
    FocusBanner,
    AllSearch,
    CenterDynamic,
    Publicity,
    Trade,
    FloatingBox,
    DealProcess,
    Adverts,
    cmsChildNode,
    Project,
  },
  metaInfo() {
    return {
      title: `${this.siteInfo?.name} - 农村综合产权流转交易服务平台 - 农村集体资产交易网`,
      meta: [
        {
          name: "keywords",
          content: `${this.siteInfo?.name},农村产权交易平台,农村综合产权流转交易服务平台,农村集体资产交易服务平台,土地流转交易网,土地拍卖网`,
        },
        {
          name: "description",
          content: `${this.siteInfo?.name}经人民政府批准设立，唯一指定的农村综合产权交易服务平台，平台以公开、公平、公正为原则，以“让土地增值，让农民增收”为宗旨，促进城乡要素跨区域流动，助力乡村振兴。`,
        },
      ],
    };
  },
  inject: ["reload"],
  data() {
    return {
      nodeData: [],

    };
  },
  computed: {
    ...mapGetters(["siteInfo", "childNodesData", "oss_pub_domain"]),
  },
  async created() {
    this.initChildNodesData([
      { code: "trend", dataRows: 5 },
      { code: "cstatute", dataRows: 5 },
      { code: "pstatute", dataRows: 5 },
      { code: "dfstatute", dataRows: 5 },
    ]);
    this.initIndexAdverts("index");
  },
  mounted() {
    this.loadConacScript();
  },
  methods: {
    ...mapActions({
      initChildNodesData: "cache/initChildNodesData",
      initIndexAdverts: "cache/initIndexAdverts",
      loadConacScript() {
        const span = document.createElement("span");
        span.id = "_ideConac";

        const script = document.createElement("script");
        script.src =
          "https://dcs.conac.cn/js/nis/44/02/00/7e6798e2c7a6fb79560e1000afd65a11/11440200MB2C90821A-20003682.js";
        script.type = "text/javascript";

        this.$refs.conacContainer.appendChild(span);
        this.$refs.conacContainer.appendChild(script);
      },
    }),
  },
};
</script>

<style lang="scss" scoped>
.prompt {
  position: relative;
  top: -10px;
  display: flex;
  background-color: rgb(243, 239, 234);
  padding: 4px 5px;
}
.prompt_text {
  font-size: 25px;
  margin-top: 2px;
  margin-left: 8px;
  color: rgb(230, 46, 46);
  font-weight: 1000;
}
.moving-text-container {
  width: 100%; /* 根据需要设置宽度 */
  overflow: hidden; /* 隐藏超出容器的部分 */
  white-space: nowrap; /* 防止文字换行 */
  position: relative; /* 便于子元素定位 */
}

.moving-text {
  font-size: 16px;
  margin-top: 1px;
  margin-left: 8px;
  color: rgb(230, 46, 46);
  font-weight: bold;
}

@keyframes moveText {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(0);
  }
}
.home_w {
  margin-top: 35px;
  .div_2 {
    margin: 0 0 10px 0;
  }
  .unified_w {
    height: 100px;
    margin: 10px 0;
  }
}
</style>
